<template>
    <MainContentSearchable 
        title="Listado de campos de deportistas" 
        id="fields" 
        v-model="filters"
        :meta="loading ? {} : fields.meta" 
        @updated="debouncedGetFields"
    >
        <template v-slot:header>
            <h3 class="card-title">Listado de campos personalizados deportistas</h3>
            <div class="card-tools">
                <Button data-cy="add-field" @click="showModal('add-fields')">Añadir campo</Button>
                <AddCampo 
                    :key="reload" 
                    :filters="{ lista_id: lista_id, is_bases: 1 }" 
                    @close="closeModal"
                    @vincularFields="vincularFields" 
                />
            </div>
        </template>

        <template v-slot:content>
            <div v-if="fields" :class="['table', { 'expanded': fields.data.length <= 3 }]">
                <ContentOrLoading>
                    <b-table v-if="!loading" hover :items="fields.data" :fields="campos">
                        <template #cell(type)="{ item }">
                            <section
                                v-if="(item.type === 'select' || item.type === 'multiselect') && item.options.length > 0"
                                :id="'select-options-tooltip-' + item.id"
                            >
                                <i class="fas fa-info-circle"></i>
                                {{ item.type }}
                                <b-tooltip :target="'select-options-tooltip-' + item.id" triggers="hover">
                                    <span 
                                        v-for="(field, index) in item.options" 
                                        :key="index"
                                        class="d-inline-block mr-1"
                                    >
                                        {{ field.name }}
                                        <span v-if="index !== item.options.length - 1">, </span>
                                    </span>
                                </b-tooltip>
                            </section>
                            <section v-else>
                                {{ item.type }}
                            </section>
                        </template>
                        <template #cell(required)="{ item }">
                            <span v-if="item.required" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(deportista)="{ item }">
                            <span v-if="item.deportista" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(representante)="{ item }">
                            <span v-if="item.representante" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent
                                :lastIndex="fields.data.length > 3 && index >= fields.data.length - 3" v-bind:options="[
                                    { type: 'action', action: () => showModal('desvincular-campo-' + item.id), label: 'Borrar' },
                                ]" 
                            />
                            <BorrarModalComponent 
                                :name="'desvincular-campo-' + item.id" 
                                title="Desvincular campo"
                                confirmButton="¿Está segur@ de desvincular el campo de los deportistas?"
                                @close="() => closeModal('desvincular-campo-' + item.id, false)"
                                @confirm="() => desvincularField(item.id)"
                            />
                        </template>
                    </b-table>
                </ContentOrLoading>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"
    import AddCampo from '@/components/backend/common/AddCampo.vue';

    export default {
        props: {
            lista_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                fields: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                campos: [
                    { key: "name", label: "Nombre", class: 'text-center' },
                    { key: "type", label: "Tipo", class: 'text-center' },
                    { key: "required", label: "Requerido", class: 'text-center' },
                    { key: "deportista", label: "Deportista", class: 'text-center' },
                    { key: "representante", label: "Representantes", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ],
                reload: 1
            }
        },
        created() {
            this.getFields();
            this.debouncedGetFields = _.debounce(this.getFields, 500)
        },
        methods: {
            getFields() {
                this.loading = true;

                const params = {
                    filters: this.filters,
                    lista_id: this.lista_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.fields.index'), params).then(res => {
                    this.fields = res.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            vincularFields(fields) {
                this.loading = true;

                const params = {
                    filters: {},
                    fields: fields,
                    lista_id: this.lista_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.fields.add'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.closeModal('add-fields', true);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.closeModal('add-fields', false);
                }).finally(() => {
                    this.loading = false;
                });
            },
            desvincularField(field_id) {
                this.loading = true;

                const params = {
                    filters: this.filters,
                    lista_id: this.lista_id,
                    field_id: field_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.fields.delete'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.closeModal('desvincular-campo-' + field_id, true)
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.closeModal('desvincular-campo-' + field_id, false)
                }).finally(() => {
                    this.loading = false;
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, creado) {
                this.$modal.hide(modal);
                if (creado) {
                    this.reload += 1;
                    this.getFields();
                }
            }
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, BorrarModalComponent, AddCampo
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>